import { FormControl, OutlinedInput } from '@mui/material';
import { Box } from '@mui/system';
import React, { ReactElement } from 'react';
import useSearchParams from '../../hooks/useSearchParams';

type SourceFilterProps = {
  viewMode?: boolean;
  fullWidth?: boolean;
};

export default function SourceFilter({ viewMode, fullWidth }: SourceFilterProps): ReactElement | null {
  const [params] = useSearchParams();

  return (
    <React.Fragment>
      {params.source && viewMode && (
        <Box component="span">
          Source: <strong>{params.source}</strong>
        </Box>
      )}
      {params.source && !viewMode && (
        <FormControl fullWidth {...(!fullWidth && { sx: { width: 150 } })}>
          <OutlinedInput type="text" size="small" disabled value={`Source: ${params.source}`} />
        </FormControl>
      )}
    </React.Fragment>
  );
}
